import { render } from "./AppVideo.vue?vue&type=template&id=7dab6eb4&scoped=true"
import script from "./AppVideo.vue?vue&type=script&lang=js"
export * from "./AppVideo.vue?vue&type=script&lang=js"

import "@/Common/Styles/appVideo.scss?vue&type=style&index=0&id=7dab6eb4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab6eb4"]])

export default __exports__